<template>
    <div class="centermodu">
        <div class="maintop">
            <div class="top-modu">
                <nmodule title="总排放量(吨/年)" link="/chome/siteDetection?siteMn=008&siteId=9">
                    <div class="content">
                        <div class="item" v-for="item in centerAllData" :key="item.id">
                            <img class="img" :src="getImage(item.dataType)" alt="">
                            <div class="contentBox">
                              <div class="info">
                                  <span class="name">{{ item.dataTypeName }}</span>
                                  <span class="value HF-Duguts">{{ item.dataTypeName == "流量" ? parseFloat(item.deviceValue).toFixed(1) : parseFloat(item.deviceValue).toFixed(3) }}</span>
                              </div>
                              <div class="process">
                                  <processCompos :value="item.rate"></processCompos>
                                  <span class="rate">{{ getRate(item) + '%' }}</span>
                              </div>
                              <div class="limit" v-show="item.limitValue">
                                  许可排放量: {{ item.limitValue }}
                              </div>
                            </div>
                            
                        </div>
                    </div>
                </nmodule>
            </div>

            <!-- <div class="top-modu">
                <div class="toptitle">
                    <span class="maint">总排放量</span>
                    <span class="sect">单位:吨/年</span>
                </div>
                <div class="allpaifang">
                    <div class="data-item" v-for="item in centerAllDataS" :key="item.id">
                        <div class="first-data">
                            <div class="name">{{ item.dataTypeName }}</div>
                            <div class="value">{{ item.saveVal }}</div>
                        </div>
                        <div class="info">
                            <processCompos :value="item.rate"></processCompos>
                            <span class="rate">{{ item.rate + '%' }}</span>
                            <span class="line">|</span>
                            <span v-if="item.dataTypeName !== 'PH'">
                                许可排放量：{{ item.limitValue }}
                            </span>
                            <span v-else>
                                限值：6-9
                            </span>
                        </div>
                    </div>
                </div>
            </div> -->

            <div class="mapss">
                <div class="bluebg" id="bluebg">
                    <mapWithPoint ref="mapRef"></mapWithPoint>
                </div>
                <div class="pointbg">
                    <div class="tool-box">
                        <div class="signboard">
                            <div class="item">
                                <div class="pp" style="background: url('/image/dw1.png') no-repeat center / cover;">
                                </div>正常
                            </div>
                            <div class="item">
                                <div class="pp" style="background: url('/image/dw2.png') no-repeat center / cover;">
                                </div>告警
                            </div>
                            <div class="item">
                                <div class="pp" style="background: url('/image/dw3.png') no-repeat center / cover;">
                                </div>断电
                            </div>
                            <div class="item">
                                <div class="pp" style="background: url('/image/dw4.png') no-repeat center / cover;">
                                </div>停机
                            </div>
                            <div class="item">
                                <div class="pp" style="background: url('/image/dw5.png') no-repeat center / cover;">
                                </div>维护
                            </div>
                            <div class="item">
                                <div class="pp" style="background: url('/image/dw6.png') no-repeat center / cover;">
                                </div>预警
                            </div>
                        </div>
                        <div class="btns">
                            <!-- <img style="margin-right:0.5rem" @click="bigSmall" src="@/assets/newscreen/button_map1.png"
                                alt=""> -->
                            <!-- <img style="margin-right:0.5rem" src="@/assets/newscreen/button_process1.png"
                                @click="$emit('showPic')" alt=""> -->
                            <img src="@/assets/newscreen/enterpic1.png" @click="goSiteHome" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Modal v-model="visual" title="三维地图" width="80%">
            <div slot="footer"></div>
        </Modal>
        <!-- <div class="eventlistb">
            <eventList></eventList>
       </div> -->
    </div>
</template>

<script>
import CountTo from 'vue-count-to'
import mapWithPoint from './mapWithPoint.vue';
import eventList from './eventList.vue';
import processCompos from '../process.vue';
import nmodule from '../nmodule.vue';

export default {
    components: {
        CountTo,
        mapWithPoint,
        eventList,
        processCompos,
        nmodule
    },
    props: ["centerAllData"],
    data() {
        return {
            visual: false,
            showImage: false,
            bigSreeen: false,
            bigWayFlag: false,
            duration: 3000,
            startVal: 0,
        }
    },
    computed: {
        centerAllDataS() {
            const must = ["CODcr", '流量', "NH3_N"]
            return this.centerAllData.filter(v => {
                return must.some(e => e === v.dataType)
            }).map(e => ({ ...e, rate: parseFloat((e.deviceValue / e.limitValue * 100).toFixed(2)) }))
            // console.log('this.centerAllData',this.centerAllData)
            // let list = [];
            // let defaultD = { dataTypeName: "", deviceValue: 0, rate: 0, limitValue: 0, id: 99 };
            // // let must = ["氮氧化物", "颗粒物", "二氧化硫", "氨氮", "化学需氧量", "VOCs"];
            // let must = ["氨氮", "化学需氧量", "流量"];

            // for (let i = 0; i < this.centerAllData.length; i++) {
            //     let d1 = this.centerAllData[i];
            //     let saveVal = d1.deviceValue.toFixed(2);
            //     if (this.centerAllData[i].dataTypeName === "氨氮") {
            //         saveVal = d1.deviceValue.toFixed(3);
            //     }
            //     list.push({
            //         ...this.centerAllData[i],
            //         saveVal: saveVal,
            //         rate: parseFloat((d1.deviceValue / d1.limitValue * 100).toFixed(2))
            //     });
            //     // must.splice(must.findIndex(item => item === this.centerAllData[i].dataTypeName), 1);
            // }
            // // console.log(must)
            // // for (let i = 0; i < must.length; i++) {
            // //     if (list.length === 6) break;
            // //     list.push({
            // //         ...defaultD,
            // //         dataTypeName: must[i],
            // //         saveVal: 0,
            // //         id: defaultD.id + i
            // //     })
            // // }
            // console.log('centerAllDataS2', must)

            // console.log(list.filter((e) => must.some(_v => _v === e.dataTypeName)))

            // return list.filter((e) => must.some(_v => _v === e.dataTypeName));
        }
    },
    methods: {
        getRate(item){
          if(!item.limitValue){
            return 0
          }else{
            return parseFloat((item.deviceValue / item.limitValue * 100).toFixed(2)) || 0
          }
        },
        getImage(path) {
          if(path == "CODcr"){
            return require("@/assets/newscreen/CODcr.png")
          }else if(path == "FlowRate"){
            return require("@/assets/newscreen/流量.png")
          }else if(path == "NH3_N"){
            return require("@/assets/newscreen/canterAD.png")
          }
            // return require(`@/assets/newscreen/${path}.png`)
        },
        goSiteHome() {
            this.$router.push({
                path: "/chome/siteDetection",
            })
        },
        drawMarker(siteList) {
            this.$refs.mapRef.drawMarker(siteList);
        },
        // 全屏操作
        bigSmall() {
            var element = document.getElementById("bluebg");
            if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
                // If in fullscreen, exit fullscreen
                var exitMethod = document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen;
                if (exitMethod) {
                    exitMethod.call(document);
                }
            } else {
                // If not in fullscreen, request fullscreen
                var requestMethod = element.requestFullscreen || element.webkitRequestFullscreen || element.mozRequestFullScreen || element.msRequestFullscreen;
                if (requestMethod) {
                    requestMethod.call(element);
                }
            }
            // this.visual = true;
            return
            // 全屏开关 true是点击放大 false是点击缩小
            let self = this;
            if (self.bigSreeen) {
                this.big();
            } else {
                this.small();
            }
            self.bigSreeen = !self.bigSreeen;
            self.bigWayFlag = true;
        },
        // 全屏
        big() {
            let element = document.documentElement;
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
            }
        },
        // 缩小
        small() {
            let element = document.documentElement;
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.centermodu {
    width: 100%;
    height: 100%;
    line-height: 1;
    font-size: 1rem;
    .maintop {
        position: relative;
        width: 100%;
        height: 100%;
        .top-modu {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 9rem !important;
            // background: url(../../../assets/newscreen/top_bg.gif) no-repeat;
            background-size: 100% 100%;
            gap: 0.5rem;
            .content {
                display: flex;
                height: 100%;
                padding: 1rem 1.1rem;
                // gap: 0.5rem;
                .item {
                    flex: 1;
                    display: grid;
                    grid-template-columns: 1fr 1.5fr;
                    grid-template-rows: 1fr 1fr 1fr;
                    // column-gap: 0.5rem;

                    color: #fff;
                    text-align: left;

                    .img {
                        grid-column: 1 / 2;
                        grid-row: 1 / 4;
                        display: block;
                        width: 80%;
                    }
                    .contentBox{
                      display: flex;
                      flex-direction: column;
                      gap:5px;
                      .info {
                          color: #67DCFF;
                          font-size: 0.8rem;
                          display: flex;
                          flex-direction: column;
                          gap:5px;
                          // gap:5px;
                          .name{
                            // margin-right: 5px;
                          }
                          .value {
                              font-size: 1.6rem;
                          }
                      }

                      .process {
                          display: flex;
                          align-items: center;
                          .rate {
                              margin-left: 0.2rem;
                          }
                      }
                          .limit{
                            font-size: 0.8rem;
                          }
                    }
                }
            }


            .toptitle {
                background-image: linear-gradient(90deg, rgba(14, 45, 101, 0.01) 0%, #061437 14%, #0B2250 43%, #061437 78%, rgba(6, 20, 53, 0.00) 100%);
                width: 17rem;
                margin: 0 auto;
                color: #F5FAFF;
                text-align: center;

                .maint {
                    font-size: 1.286rem;
                    margin-right: 0.25rem;
                    text-shadow: 0 2px 4px #44D7B6;
                    font-weight: 600;
                }

                .sect {
                    font-size: 1rem;
                }
            }
        }

        .allpaifang {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            height: 100%;
            padding: 0 1rem 3rem 1rem;

            .data-item {
                width: 49.5%;
                // width: 33.333%;
                display: flex;
                align-items: flex-start;
                justify-content: center;
                flex-direction: column;
                padding: 0 1rem;

                .first-data {
                    display: flex;
                    align-items: center;
                }

                .name {
                    color: #fff;
                    font-size: 1.5rem;
                    white-space: nowrap;
                    margin-right: 0.5rem;
                }

                .value {
                    font-size: 1.75rem;
                    color: #fff;
                    font-weight: 900;
                    margin: 0.25rem 0 0.25rem 0;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    width: 100%;
                    white-space: nowrap;
                    text-align: left;
                    text-shadow: 0 0 1rem #44D7B6;
                }

                .info {
                    display: flex;
                    align-items: center;
                    color: #fff;
                    font-size: 0.875rem;
                    white-space: nowrap;

                    .rate {
                        margin-left: 0.5rem;
                    }

                    .line {
                        margin: 0 0.25rem;
                    }
                }
            }

            .data-item:nth-child(2),
            .data-item:nth-child(4) {
                border: 1px solid transparent;
                border-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0), #58D1FF, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)) 1;
                border-top: 0;
                border-bottom: 0;
            }
        }

        .mapss {
            width: 100%;
            height: 100%;
            padding-top: 9rem !important;
            .bluebg {
                width: 100%;
                height: calc(100% - 5rem);
                background: url(../../../assets/newscreen/mapbg.png) no-repeat;
                background-size: 100% 100%;
                padding: 1rem;
            }

            .pointbg {
                width: 100%;
                height: 5rem;
                background: url(../../../assets/newscreen/bg_process.png) no-repeat;
                background-size: 105% 110%;
                background-position: center bottom;
                display: flex;
                align-items: center;

                .tool-box {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                }

                .signboard {
                    display: flex;
                    padding-left: 1rem;

                    .item {
                        width: 50%;
                        color: #fff;
                        font-size: 0.75rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-right: 0.24rem;

                        .pp {
                            display: inline-block;
                            width: 16px;
                            height: 16px;
                            margin-right: 0.25rem;
                        }
                    }
                }

                .btns {
                    display: flex;

                    img {
                        height: 3rem;
                        cursor: pointer;
                    }
                }
            }
        }
    }

    .eventlistb {
        width: 100%;
        height: 30%;
    }
}

// @media screen and (max-height: 960px) {

//     .centermodu .maintop .top-modu {
//         height: 22vh !important;
//     }

//     .centermodu .maintop .mapss {
//         padding-top: 22vh !important;
//     }
// }
</style>
